import React, { Component } from 'react';
import { Provider, observer } from 'mobx-react';
import { history } from "../../history_mobx";
import myStore from "../../stores/store";
import { Router } from "react-router";
import { Switch, Route, NavLink } from "react-router-dom";
import SpyingWithStore from "./SpyingWithStore";
import ScrollToTop from "../Helpers/ScrollToTop";
import ScrollRestoration from 'react-scroll-restoration'


class SpyingOnly extends Component {
  render() {
    return (
      <Provider {...myStore.getStores()}>
          <Router history={history}>
            <ScrollRestoration/>
            <Switch>
              <Route exact path="/spying/all/"  render={(props)=>{ return ( <SpyingWithStore standalone={true} {...props} /> ); } } />
              <Route exact path={["/spying/blog/", "/spying/blog/:id"]}  render={(props)=>{ return ( <SpyingWithStore standalone={true} category_id={62} {...props} /> ); } } />
              <Route exact path={["/spying/figurines/", "/spying/figurines/:id"]}  render={(props)=>{ return ( <SpyingWithStore standalone={true} category_id={51} {...props} /> ); } } />
              <Route exact path={["/spying/photos/", "/spying/photos/:id"]}  render={(props)=>{ return ( <SpyingWithStore standalone={true} category_id={56} {...props} /> ); } } />
              <Route exact path={["/spying/anime/", "/spying/anime/:id"]}  render={(props)=>{ return ( <SpyingWithStore standalone={true} category_id={74} {...props} /> ); } } />
              <Route exact path={["/spying/characters/", "/spying/characters/:id"]}  render={(props)=>{ return ( <SpyingWithStore standalone={true} category_id={80} {...props} /> ); } } />
              <Route exact path={["/spying/news/", "/spying/news/:id"]}  render={(props)=>{ return ( <SpyingWithStore standalone={true} category_id={52} {...props} /> ); } } />
            </Switch>
          </Router>
      </Provider>
    );
  }
}

export default observer(SpyingOnly);
